import styled from "styled-components";

export const SpinnerWrapper = styled.div`
  margin-top: 2rem;
`;
